






























import ActionButton from '@/components/ActionButton.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { RemittancePrice } from '@/utils/interfaces/remittance.interface'
import { User } from '@/api/Auth/auth.interface'
import WholesalerDialog from '@/components/Services/Remittances/Wholesaler/WholesalerDialog.vue'
import { getWholesalers } from '@/api/Remittances/remittances.api'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<User>().extend({
  components: {
    appActionButton: ActionButton,
    appWholesalerDialog: WholesalerDialog,
    FlatCard,
    FlatTable,
  },
  data() {
    return {
      getter: getWholesalers,
      priceItem: null as null | RemittancePrice,
      headers: [
        {
          text: this.$t('username'),
          value: 'username',
        },
        {
          text: this.$t('name'),
          value: 'first_name',
        },
        {
          text: this.$t('lastname'),
          value: 'last_name',
        },
        {
          text: this.$t('phone'),
          value: 'phone',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: this.$t('balance'),
          value: 'balance',
        },
        {
          text: this.$t('settings'),
          value: 'wholesaler',
        },
      ],
    }
  },
})
